import TermTargetTypeEligibilityDeterminer from './TermTargetTypeEligibilityDeterminer'

class ConstantTargetTypeEligibilityDeterminer extends TermTargetTypeEligibilityDeterminer {}

export default ConstantTargetTypeEligibilityDeterminer
